import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LayoutComponent } from './page/layout/layout.component';
import { AppHeaderComponent } from './page/layout/header/header.component';
import { AppFooterComponent } from './page/layout/footer/footer.component';
import { DefaultComponent } from './page/default/default.component';
import { AboutUsComponent } from './page/about-us/about-us.component';
import { SliderComponent } from './page/default/slider/slider.component';
import { DefaultNowSellComponent } from './page/default/now-sell/now-sell.component';
import { CatalogComponent } from './page/default/catalog/catalog.component';
import { ModuleComponent } from './page/default/module/module.component';
import { NewsComponent } from './page/default/news/news.component';
import { ServicesComponent } from './page/default/services/services.component';
import { MobileAppComponent } from './page/default/mobile-app/mobile-app.component';
import { DigitalComponent } from './page/default/digital/digital.component';
import { MediaComponent } from './page/media/media.component';
import { NowSellComponent } from './page/now-sell/now-sell.component';
import { PricingComponent } from './page/pricing/pricing.component';
import { ProductsComponent } from './page/products/products.component';
import { ContactComponent } from './page/contact/contact.component';
import { ProductContactComponent } from './page/product-contact/product-contact.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask';
import { NgxLoadingModule } from 'ngx-loading';
import { RecaptchaModule } from 'ng-recaptcha';
import { HttpClientModule } from '@angular/common/http';
import { BeOurDelaerComponent } from './page/beourdealer/be-our-dealer.component';
import { MobileContactComponent } from './page/mobile/mobile-contact.component';
import { MobileBeOurDealerComponent } from './page/mobile/mobile-be-our-dealer.component';
import { MobileLayoutComponent } from './page/mobile/mobile-layout.component';
import { MobileAccountDeletionComponent } from './page/mobile/mobile-account-deletion.component';
import { AppBannerModalComponent } from './page/layout/app-banner-modal/app-banner-modal.component';
import { AppRedirectComponent } from './page/app-redirect/app-redirect.component';

@NgModule({
  declarations: [
    AppComponent,
    LayoutComponent,
    AppHeaderComponent,
    AppFooterComponent,
    DefaultComponent,
    SliderComponent,
    DefaultNowSellComponent,
    CatalogComponent,
    ModuleComponent,
    NewsComponent,
    ServicesComponent,
    MobileAppComponent,
    DigitalComponent,
    BeOurDelaerComponent,
    MobileLayoutComponent,
    MobileContactComponent,
    MobileBeOurDealerComponent,
    MobileAccountDeletionComponent,
    AppBannerModalComponent,
    AppRedirectComponent,

    AboutUsComponent,
    ContactComponent,
    MediaComponent,
    NewsComponent,
    NowSellComponent,
    PricingComponent,
    ProductContactComponent,
    ProductsComponent

  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,

    NgxMaskModule.forRoot(),
    NgxLoadingModule.forRoot({}),
    RecaptchaModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
